import React from 'react';
import { AiFillDelete } from 'react-icons/ai';
import styled from 'styled-components';
import { undoableSetDebugStartMarkerOp } from '../../stores/undo/operation/MapEditorDebugStartMarkerChangeOp';
import { MenuCard } from '../menu/MenuCard';
import { MenuCardLabel } from '../menu/MenuCardLabel';
import { LayerDeleteButton } from './EditorTileInspectorLayer';
const TitleBar = styled.div.withConfig({
  displayName: "DebugStartMarkerPropertiesEditor__TitleBar",
  componentId: "sc-6vfec7-0"
})(["display:flex;"]);
const TitleName = styled(MenuCardLabel).withConfig({
  displayName: "DebugStartMarkerPropertiesEditor__TitleName",
  componentId: "sc-6vfec7-1"
})(["flex-grow:1;"]);
const Buttons = styled.div.withConfig({
  displayName: "DebugStartMarkerPropertiesEditor__Buttons",
  componentId: "sc-6vfec7-2"
})(["flex-shrink:0;"]);
export const DebugStartMarkerPropertiesEditor = () => {
  const deleteElement = () => {
    undoableSetDebugStartMarkerOp(null, null);
  };

  return /*#__PURE__*/React.createElement(MenuCard, null, /*#__PURE__*/React.createElement(TitleBar, null, /*#__PURE__*/React.createElement(TitleName, null, /*#__PURE__*/React.createElement("div", null, "Debug Start")), /*#__PURE__*/React.createElement(Buttons, null, /*#__PURE__*/React.createElement(LayerDeleteButton, {
    onClick: deleteElement
  }, /*#__PURE__*/React.createElement(AiFillDelete, null)))));
};